import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon } = colorsPalettes;

export const Header = styled(FlexRow)`
    box-sizing: border-box;
    align-items: center;
    gap: 16px;
    width: 100%;
`;
export const Title = styled.h5`
    ${setFontVariant("h5", carbon[500])};
    margin: 0;
`;
